import { Component, ElementRef, OnInit } from '@angular/core';
import { ChangedetectorReference } from '../../../../../../../../../core/changedetector/changedetectoreference';
import { NGXSimpleSeriesChartComponent } from '../../ngx-simple-series-chart.class';
import {
  BarChartDisplayOptions,
  SimpleHorizontalBarChart
} from '../../../../../../../../../core/models/ETG_SABENTISpro_Application_Core_models';

@Component({
  selector: 'app-simple-horizontal-bar-chart',
  templateUrl: './simple-horizontal-bar-chart.component.html',
  styleUrls: ['./simple-horizontal-bar-chart.component.scss'],
  providers: [ChangedetectorReference]
})
export class SimpleHorizontalBarChartComponent extends NGXSimpleSeriesChartComponent<SimpleHorizontalBarChart, BarChartDisplayOptions> implements OnInit {

  constructor(protected cdReference: ChangedetectorReference,
              protected elementRef: ElementRef) {
    super(cdReference);
  }

  public initializeChart(): void {
    super.initializeChart();
  }

  GetViewValueOnInitializeChart(): [number, number] {
    const calculatedView: [number, number] = this.GetDefaultViewValueOnResize(this.elementRef);
    return [calculatedView[0], this.numSeries * 70];
  }

  GetViewValueOnResize(): [number, number] {
    const calculatedView: [number, number] = this.GetDefaultViewValueOnResize(this.elementRef);
    return [calculatedView[0], this.numSeries * 70];
  }
}
